export default {
  using_association: [], // 使用中的组织
  stoped_association: [], // 停用的组织
  current_channel: -1,
  current_association: { name: '' }, // 当前选中的组织
  users_in_current_channel: [], // 当前组织下的用户
  search: ''
}
